export enum AdobeEnum {
  ADOBE_ELEMENT_ID = 'adobe-launch-script'
}
